import { render, staticRenderFns } from "./KeysDexIdModal.vue?vue&type=template&id=4db034b6&scoped=true"
import script from "./KeysDexIdModal.vue?vue&type=script&lang=ts"
export * from "./KeysDexIdModal.vue?vue&type=script&lang=ts"
import style0 from "./KeysDexIdModal.vue?vue&type=style&index=0&id=4db034b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db034b6",
  null
  
)

export default component.exports